import { EuiFormLabel, EuiSelect } from '@elastic/eui';
import { vendorType } from 'cache';
import { VendorType } from 'generated/graphql';
import { useLocalCache } from 'hooks/useLocalCache';
import { useIntl } from 'react-intl';

import * as S from './FiltersSidebar.styles';

export const VendorTypeFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.vendorType.label' })}</EuiFormLabel>
      <EuiSelect
        placeholder={formatMessage({ id: 'filters.vendorType.placeholder' })}
        onChange={(x): string | undefined => vendorType(x.target.value as string)}
        value={localFilters.data?.vendorType as string}
        options={Object.values(VendorType).map((vendor) => ({
          value: vendor,
          text: formatMessage({ id: `vendorType.${vendor}` }),
        }))}
      />
    </S.SidebarFilterWrapper>
  );
};
